@if (lesson | async; as lesson) {
  <ng-container class="lesson">
    <header class="lesson-header">
      <div>
        <h1>Identification, Strategy and Hypothesis</h1>
        <p>{{lesson.strategyIdentificationCopy}}</p>
      </div>
    </header>
    <section class="lesson-content">
      <div class="lesson-problem">
        <app-content-viewer [content]=lesson.problem.content></app-content-viewer>
        @if (utilitiesService.problemHasContentPassage(lesson.problem)) {
          <div class="lesson-passage" >
            <app-content-viewer [content]=lesson.problem.passage.content></app-content-viewer>
          </div>
        }
      </div>
      <div class="lesson-answers">
        @if (topics | async; as topics) {
          <app-multi-choice
            [options]="topics"
            [idField]="'id'"
            [title]="lesson.strategyIdentificationPrompt"
            [correctTitle]="lesson.strategyIdentificationCorrectCopy"
            [incorrectTitle]="lesson.strategyIdentificationIncorrectCopy"
            [displayField]="'strategyName'" (optionSelected)="handleSelectedTopic($event, lesson)">
          </app-multi-choice>
        } @else {
          <ng-template [ngTemplateOutlet]="loadingTopics"></ng-template>
        }
        <ng-template #loading2>
          <app-spinner></app-spinner>
        </ng-template>
        @if (readyToContinue) {
          <a class="btn btn-lg btn-block btn-primary" [routerLink]="['../strategy-hypothesis']">
            Next
          </a>
        }
      </div>
    </section>
  </ng-container>
} @else {
  <app-spinner></app-spinner>
}

